import React, { useState } from "react";
import { Badge } from "react-bootstrap";
import { IconDefinition, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const CardSelect = ({
  id,
  icon,
  text,
  selected,
  onSelect,
  badgeText,
  smallText,
  long = false,
}: {
  id?: string,
  icon: IconDefinition,
  text: string,
  selected: boolean,
  onSelect: () => void,
  badgeText?: string,
  smallText?: string,
  long?: boolean,
}) => {
  const [hover, setHover] = useState(false);
  const handleMouseEnter = () => {
    setHover(true);
  };
  const handleMouseLeave = () => {
    setHover(false);
  }

  if (long) {
    return (
      <div className="p-0 mx-auto mt-3 w-100" id={id}>
        <div className={`px-4 py-3 border h-100 rounded d-flex flex-row  ${selected || hover ? 'glow' : ''}`} onClick={onSelect} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{ cursor: 'pointer', backgroundColor: selected || hover ? 'var(--bs-dark)' : '' }}>
          <div className={`d-flex ${selected || hover ? 'text-light' : 'text-muted'}`}>
            <FontAwesomeIcon icon={icon} size="3x" className={`text-center my-auto`} />
          </div>
          <div className="flex-grow ml-4">
            <div className="">
              {text} <Badge variant="light">{badgeText}</Badge>
            </div>
            {smallText && <div className="text-secondary">{smallText}</div>}
          </div>
        </div>
      </div>
    )
  }



  return (
    <div className="p-0 mx-auto w-100" id={id} >
      <div className={`p-4 border h-100 rounded d-flex flex-column ${selected || hover ? 'glow' : ''} `} onClick={onSelect} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{ cursor: 'pointer', backgroundColor: selected || hover ? 'var(--bs-dark)' : '' }}>
        <div className={`${selected || hover ? 'text-light' : 'text-muted'}`}>
          <FontAwesomeIcon icon={icon} size="3x" className={`text-center ${selected || hover ? 'text-light' : ''}`} />
        </div>
        <div className="mt-2 text-center">
          {text} <Badge variant="light">{badgeText}</Badge>
        </div>
        {smallText && <div className="text-secondary">{smallText}</div>}
      </div>
    </div>
  )
}